import { Resolutions, Timeout } from "../common/const";
import { isWidthResize, findAncestorByClassname, findAncestorByAttr } from "../common/utils";

/**
 * Скролл таблицы на страницы "Сравнение"
 * @table_scroll
 */
class Compare {
    constructor(table) {
        this.table = table;
        this.CONST = {
            VIEW_COLS_DP: 3, // видимые колонки на десктопе
            VIEW_COLS_MOB: 2 // видимые колонки на планшете/мобилке
        };
        this.page = findAncestorByClassname(this.table, `compare`);
        this.tabs = document.querySelectorAll(`[data-tab-block]`);
        this.productsCountBlocks = document.querySelectorAll(`[data-products-count]`);
        this.rows = this.table.querySelectorAll(`[data-row]`); // строки
        this.cols = this.table.querySelectorAll(`[data-col]`); // колонки
        this.btnPrev = this.table.querySelector(`[data-scroll-btn="prev"]`); // кнопка слайдера "назад"
        this.btnNext = this.table.querySelector(`[data-scroll-btn="next"]`); // кнопка слайдера "вперед"
        this.btnDelete = this.table.querySelectorAll(`[data-delete]`); // кнопка "удалить товар из сравнения"
        this.fixedBlock = this.table.querySelector(`[data-fixed-row]`);
        this.fixedHeight = this.fixedBlock.offsetHeight;
        this.length = this.getColsLength(); // количество колонок
        this.colWidth = this.getColWidth(); // ширина одной колонки
        this.transform = 0;
        this.index = 0;
        this.productHeight = this.fixedBlock.querySelector(`.product__right`).offsetHeight;
        this.margin = this.getMargin(); // отступы между колонками
        this.viewCols = this.getViewCols(); // количество видимых колонок на странице
        this.onWidthResize = () => this.onResize();
        this.onArrowClick = this.onArrowClick.bind(this);
        this.onWindowScroll = this.onWindowScroll.bind(this);
        this.onDeleteBtnClick = this.onDeleteBtnClick.bind(this);
    }

    // получить количество колонок
    getColsLength() {
        return this.rows[0].querySelectorAll(`[data-col]`).length;
    }

    // получить полную ширину строки
    getRowWidth() {
        // return this.rows[0].offsetWidth;
        return this.margin ? (this.viewCols * this.colWidth) - this.margin : this.viewCols * this.colWidth;
    }

    // получить ширину колонки
    getColWidth() {
        return this.cols[0].offsetWidth;
    }

    // получить отступы у колонок
    getMargin() {
        const element = this.cols[0];
        const style = window.getComputedStyle(element);
        const marginRight = style.getPropertyValue(`margin-right`);
        return parseInt(marginRight.replace(`px`, ``));
    }

    // получить количество видимых колонок
    getViewCols() {
        if (Resolutions.IS_NOT_MOB()) {
            return this.CONST.VIEW_COLS_DP;
        } else {
            return this.CONST.VIEW_COLS_MOB;
        }
    }

    // Максимальное значение смещение таблицы
    calcWidth() {
        this.colWidth = this.getColWidth();
        this.length = this.getColsLength();
        this.margin = this.getMargin();
        let maxWidth = this.margin ? (this.length * this.colWidth) - this.margin : this.length * this.colWidth;
        let width = this.getRowWidth();
        return Math.round(maxWidth - width);
    }

    // дизейбл слайдера если количество колонок меньше чем видимых на данном разрешении
    disabledTable() {
        if (this.length <= this.viewCols) {
            this.table.classList.add(`disabled`);
        } else {
            this.table.classList.remove(`disabled`);
        }
    }

    // смещение строк слайдера
    transformRows(num) {
        this.rows.forEach((row) => {
            row.style.transform = `translateX(${num}px)`;
        });
    }

    // возвращение слайдера на стартовую позицию
    transformRowsToStartPosition() {
        this.transformRows(0);
        this.index = 0;
        this.transform = 0;
    }

    // Добавление обработчика событий на дп или сброс всего на планшете
    onResize() {
        this.margin = this.getMargin();
        this.viewCols = this.getViewCols();
        this.updateSlider();
        this.fixedHeight = this.fixedBlock.offsetHeight;
        this.productHeight = this.fixedBlock.querySelector(`.product__right`).offsetHeight;

        this.tabs.forEach(tab => tab.style.display = ``);

        if (Resolutions.IS_TAB()) {
            this.transformRowsToStartPosition();
            window.removeEventListener(`scroll`, this.onWindowScroll);
        } else {
            window.addEventListener(`scroll`, this.onWindowScroll);
        }

        this.disabledTable();
        this.updateTabs();
    }

    // обновление табов
    updateTabs() {
        const tabBlocks = this.page.querySelectorAll(`[data-tab-block]`);
        const tabs = this.page.querySelectorAll(`[data-tab]`);

        if (Resolutions.IS_DP()) {
            tabBlocks[0].classList.add(`active`);
            tabs[0].classList.add(`active`);
        } else {
            for (let block of tabBlocks) block.classList.remove(`active`);
            for (let block of tabs) block.classList.remove(`active`);
        }
    }

    // обновить слайдер
    updateSlider() {
        this.length = this.getColsLength();
        this.viewCols = this.getViewCols();
        this.colWidth = this.getColWidth();
        this.disabledTable();
    }

    getProductsCount() {
        return document.querySelectorAll(`[data-product-id]`).length;
    }

    // set total item amount
    updateProductsCount() {
        let productsCountBlocks = document.querySelectorAll(`[data-products-count]`);
        let total = this.getProductsCount() || 0;

        productsCountBlocks.forEach((block) => {
            block.textContent = total.toString();
        });
    }

    // свайп пальцами
    onSwipe() {
        if (this.length <= this.viewCols) return;

        this.rows.forEach(row => {
            $(row).swipe({
                swipeLeft: () => {
                    if (this.calcWidth() !== this.transform) {
                        this.btnNext.click();
                    }
                },
                swipeRight: () => {
                    if (this.index !== 0) {
                        this.btnPrev.click();
                    }
                }
            });
        });
    }

    // клик по стрелкам слайдера
    onArrowClick(e) {
        const target = e.target;
        this.updateSlider();

        if (target.getAttribute(`data-scroll-btn`) === `next`) {
            this.index++;
            this.btnPrev.classList.remove(`disabled`);
        } else if (target.getAttribute(`data-scroll-btn`) === `prev`) {
            this.index--;
            this.btnNext.classList.remove(`disabled`);
        }

        this.transform = Math.round(this.colWidth * this.index);

        if (this.calcWidth() >= this.transform) {
            this.transformRows(this.transform * -1);
        }

        if (this.calcWidth() === this.transform || this.index === 0) {
            target.classList.add(`disabled`);
        }
    }

    removeItemFromSlider(element) {
        element.parentNode.removeChild(element);
    }

    // удалить товар из сравнения
    onDeleteBtnClick(e) {
        const target = e.target;
        const attr = findAncestorByAttr(target, `data-product-id`).getAttribute(`data-product-id`);
        const currentTab = findAncestorByAttr(target, `data-tab-block`);
        const sectionId = currentTab.getAttribute(`data-tab-block`);
        let currentTabLink;

        if (Resolutions.IS_DP()) {
            currentTabLink = document.querySelector(`[data-tab="${sectionId}"]`);
        } else {
            currentTabLink = document.querySelector(`[data-src="#${sectionId}"]`);
        }

        if (window.compare && typeof window.compare === `function`) window.compare(attr, `DELETE_FROM_COMPARE_LIST`);

        this.cols.forEach((it) => {
            if (attr === it.getAttribute(`data-col`)) {
                this.removeItemFromSlider(it);
            }
        });

        this.updateSlider();


        if (this.length <= 0) {
            $.fancybox.close();

            if (currentTabLink.nextElementSibling) {
                currentTabLink.nextElementSibling.click();
            } else if (currentTabLink.previousElementSibling) {
                currentTabLink.previousElementSibling.click();
            }

            this.removeItemFromSlider(currentTabLink);
            this.removeItemFromSlider(currentTab);
        } else {
            currentTabLink.querySelector(`.f-button-xs`).textContent = this.length;
        }

        if (this.length <= this.viewCols) {
            this.transformRowsToStartPosition();
        } else if (this.length - this.index < this.viewCols) {
            this.index--;
            this.transform = Math.round(this.colWidth * this.index);
            this.transformRows(this.transform * -1);
        }

        this.updateProductsCount();

        this.table.querySelectorAll(`[data-col]`).forEach((it, index) => {
            let counter = it.querySelector(`.compare__counter`);
            if (!counter) return;
            counter.textContent = `${index + 1} из ${this.length}`;
        });

        // перезагрузка, если товаров нет
        if (this.getProductsCount() === 0) {
            setTimeout(() => {
                location.reload();
            }, Timeout.LONG_TIMEOUT);
        }
    }

    onWindowScroll() {
        const activeTable = this.table.parentElement.classList.contains(`active`);
        const isModal = this.table.parentElement.classList.contains(`modal`);

        if ((activeTable && Resolutions.IS_DP()) || isModal) {
            const next = this.fixedBlock.nextElementSibling;
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let scrollHeight = next.getBoundingClientRect().top - this.productHeight + window.scrollY;

            if (scrollTop >= scrollHeight) {
                this.table.style.paddingTop = this.fixedHeight + `px`;
                this.table.classList.add(`fixed`);
                if (!isModal) this.table.querySelector(`.compare__row--fixed`).style.top = document.querySelector(`.header`).offsetHeight + `px`;
                else this.table.querySelector(`.compare__row--fixed`).style.top = `0px`;

            } else {
                this.table.style.paddingTop = ``;
                this.table.classList.remove(`fixed`);
                this.table.querySelector(`.compare__row--fixed`).style.top = ``;
            }
        }
    }

    addEvents() {
        this.btnPrev.addEventListener(`click`, this.onArrowClick);
        this.btnNext.addEventListener(`click`, this.onArrowClick);
        this.btnDelete.forEach((btn) => btn.addEventListener(`click`, this.onDeleteBtnClick));
        window.addEventListener(`scroll`, this.onWindowScroll);

        for (let tab of this.tabs) {
            tab.addEventListener(`scroll`, (e) => {
                if (Resolutions.IS_TAB()) {
                    this.onWindowScroll();
                }
            }, false);
        }
        this.onSwipe();
    }

    init() {
        this.disabledTable();
        this.addEvents();
        this.updateTabs();
        this.updateProductsCount();
        isWidthResize(this.onWidthResize);
    }
}

export const initCompare = () => {
    const tables = document.querySelectorAll(`.js-scrolled-table`);
    tables.forEach((table) => new Compare(table).init());
};

window.initCompare = (block) => new Compare(block).init();
